<template>

  <card title="Transactions" :subtitle="subtitle">
    <div>
      <Transactions-Table/>
    </div>
    <!-- <div slot="footer" class="stats">
      <i class="far fa-clock"/> This Month
    </div> -->
  </card>
  
</template>

<script>
export default {
  name: 'Transactions-Card',
  computed: {
    subtitle () {
      let label = this.$store.getters.periodSelected ? this.$store.getters.periodSelected.label : ''
      if (label == 'This Month+') label = 'This Month'
      return label ? label : ''
    }
  }
}
</script>

<style>

</style>
